import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';
import emailjs from '@emailjs/browser';

const TURKIYE_SEHIRLER = ['Adana','Adıyaman','Afyonkarahisar','Ağrı','Amasya','Ankara','Antalya','Artvin','Aydın','Balıkesir','Bilecik','Bingöl','Bitlis','Bolu','Burdur','Bursa','Çanakkale','Çankırı','Çorum','Denizli','Diyarbakır','Edirne','Elazığ','Erzincan','Erzurum','Eskişehir','Gaziantep','Giresun','Gümüşhane','Hakkari','Hatay','Isparta','İçel (Mersin)','İstanbul','İzmir','Kars','Kastamonu','Kayseri','Kırklareli','Kırşehir','Kocaeli','Konya','Kütahya','Malatya','Manisa','Kahramanmaraş','Mardin','Muğla','Muş','Nevşehir','Niğde','Ordu','Rize','Sakarya','Samsun','Siirt','Sinop','Sivas','Tekirdağ','Tokat','Trabzon','Tunceli','Şanlıurfa','Uşak','Van','Yozgat','Zonguldak','Aksaray','Bayburt','Karaman','Kırıkkale','Batman','Şırnak','Bartın','Ardahan','Iğdır','Yalova','Karabük','Kilis','Osmaniye','Düzce'];

export default function SiparisOlustur() {
  const { profil } = useAuth();
  const navigate = useNavigate();
  const [adim, setAdim] = useState(1);

  const [firmalar, setFirmalar] = useState([]);
  const [urunler, setUrunler] = useState([]);
  const [depolar, setDepolar] = useState([]);
  const [stokMap, setStokMap] = useState({});

  const [seciliFirma, setSeciliFirma] = useState('');
  const [seciliGrup, setSeciliGrup] = useState('');
  const [seciliAltGrup, setSeciliAltGrup] = useState('');
  const [urunArama, setUrunArama] = useState('');
  const [sepet, setSepet] = useState([]);
  const [satisGrubu, setSatisGrubu] = useState({}); // urun_id -> 'veteriner' | 'hasta_yakini'

  const [entegreFiyatlar, setEntegreFiyatlar] = useState({});
  const [entegreFiyatAcik, setEntegreFiyatAcik] = useState({});
  const [musteriArama, setMusteriArama] = useState('');
  const [musteriSonuclar, setMusteriSonuclar] = useState([]);
  const [seciliMusteri, setSeciliMusteri] = useState(null);
  const [yeniMusteri, setYeniMusteri] = useState(false);
  const [musteriAraniyor, setMusteriAraniyor] = useState(false);

  const [form, setForm] = useState({
    yeni_musteri_ad: '', yeni_musteri_tel: '', yeni_musteri_sehir: '', yeni_musteri_tip: 'faturasiz_vet',
    musteri_tipi: 'bireysel', depo_id: '', odeme_turu: 'banka', kdv_durumu: false,
    adres: '', not_: '', fatura_durumu: false, kargo_kodu: '', sehir: '',
    broiler_satis_tipi: 'ciftlik', entegre_manuel_fiyat: '',
  });

  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState('');

  useEffect(() => { fetchFirmalar(); fetchDepolar(); }, []);
  useEffect(() => { if (seciliFirma) fetchUrunler(); }, [seciliFirma]);
  useEffect(() => { if (form.depo_id && urunler.length > 0) fetchStoklar(); }, [form.depo_id, urunler]);

  useEffect(() => {
    if (musteriArama.length < 2) { setMusteriSonuclar([]); return; }
    const timer = setTimeout(() => araMusteri(musteriArama), 300);
    return () => clearTimeout(timer);
  }, [musteriArama]);

  async function araMusteri(q) {
    setMusteriAraniyor(true);
    let sorgu = supabase.from('musteriler').select('*').eq('aktif', true).limit(10);
    if (profil?.rol === 'temsilci') sorgu = sorgu.eq('temsilci_id', profil.id);
    sorgu = sorgu.or(`ad.ilike.%${q}%,telefon.ilike.%${q}%`);
    const { data } = await sorgu;
    setMusteriSonuclar(data || []);
    setMusteriAraniyor(false);
  }

  async function musteriSec(m) {
    setSeciliMusteri(m);
    setMusteriArama(m.ad);
    setMusteriSonuclar([]);
    const { data: g } = await supabase.from('musteriler').select('adres, sehir, ilce, telefon').eq('id', m.id).single();
    const adres = g?.adres || m.adres || '';
    const rawSehir = g?.sehir || m.sehir || '';
    const sehirNorm = TURKIYE_SEHIRLER.find(s => s.toLowerCase() === rawSehir.toLowerCase()) || rawSehir;
    setForm(f => ({ ...f, adres, yeni_musteri_sehir: sehirNorm, sehir: sehirNorm }));
  }

  async function fetchFirmalar() {
    let q = supabase.from('firmalar').select('id, ad').eq('aktif', true);
    if (profil?.rol === 'temsilci') {
      const { data: yetkiler } = await supabase.from('temsilci_firma_yetki').select('firma_id').eq('kullanici_id', profil.id);
      const ids = (yetkiler || []).map(y => y.firma_id);
      if (ids.length > 0) q = q.in('id', ids);
    }
    const { data } = await q;
    const FIRMA_SIRA = {
      'acb52946-e2a8-4fac-84db-04865b85f944': 0,
      '5556578b-e620-4abc-837f-fb8549cfe512': 1,
      '408634a3-a463-43e8-b01e-2e55ce7ad9fb': 2,
    };
    const siralamali = (data || []).sort((a, b) => (FIRMA_SIRA[a.id] ?? 99) - (FIRMA_SIRA[b.id] ?? 99));
    setFirmalar(siralamali);
    if (siralamali?.length === 1) setSeciliFirma(siralamali[0].id);
  }

  async function fetchDepolar() {
    const { data } = await supabase.from('depolar').select('id, ad, sehir').eq('aktif', true);
    setDepolar(data || []);
  }

  async function fetchUrunler() {
    const { data } = await supabase.from('urunler').select('*').eq('firma_id', seciliFirma).eq('aktif', true);
    setUrunler(data || []);
  }

  async function fetchStoklar() {
    const { data } = await supabase.from('depo_stok').select('urun_id, miktar').eq('depo_id', form.depo_id);
    const map = {};
    (data || []).forEach(s => { map[s.urun_id] = s.miktar; });
    setStokMap(map);
  }

  function satisGrubuSec(urunId, grup) {
    setSatisGrubu(prev => ({ ...prev, [urunId]: grup }));
  }

  const FIPGL23_ID = 'acb52946-e2a8-4fac-84db-04865b85f944';
  const BROILER_ID = '408634a3-a463-43e8-b01e-2e55ce7ad9fb';

  function birimFiyat(urun) {
    if (urun.firma_id === BROILER_ID) {
      if (form.broiler_satis_tipi === 'ciftlik') return urun.ciftlik_fiyat || 0;
      if (form.broiler_satis_tipi === 'bayi') return urun.bayi_fiyat || 0;
      if (form.broiler_satis_tipi === 'entegre') return parseFloat(entegreFiyatlar[urun.id]) || 0;
      return urun.ciftlik_fiyat || 0;
    }
    const grup = satisGrubu[urun.id] || (urun.satis_tipi === 'hasta_yakini' ? 'hasta_yakini' : 'veteriner');
    if (urun.firma_id === FIPGL23_ID) {
      return grup === 'hasta_yakini' ? urun.hya_banka_fiyat : urun.banka_fiyat_kdvsiz;
    }
    if (form.odeme_turu === 'kredi_karti') {
      return grup === 'hasta_yakini' ? urun.hya_kk_fiyat : urun.kk_fiyat_kdvli;
    }
    return grup === 'hasta_yakini' ? urun.hya_banka_fiyat : urun.banka_fiyat_kdvsiz;
  }

  function komisyonHesapla(urun, miktar) {
    if (urun.komisyonsuz) return 0;
    const fiyat = birimFiyat(urun);
    let oran = 0;
    if (urun.firma_id === BROILER_ID) {
      if (form.broiler_satis_tipi === 'ciftlik') oran = urun.ciftlik_komisyon || 0;
      else if (form.broiler_satis_tipi === 'bayi') oran = urun.bayi_komisyon || 0;
      else if (form.broiler_satis_tipi === 'entegre') oran = urun.entegre_komisyon || 0;
    } else {
      oran = (urun.firma_id === FIPGL23_ID || form.musteri_tipi !== 'kurumsal')
        ? urun.bireysel_komisyon : urun.kurumsal_komisyon;
    }
    return ((fiyat * miktar) * ((oran || 0) / 100));
  }

  function sepeteEkle(urun) {
    if (!form.depo_id) { setHata('Lütfen önce depo seçin!'); return; }
    const stok = stokMap[urun.id];
    if (stok === undefined || stok === 0) { setHata(`⛔ "${urun.ad}" ürününün depoda stoğu YOK.`); return; }
    setHata('');
    const fiyat = birimFiyat(urun);
    const komisyon = komisyonHesapla(urun, 1);
    setSepet(prev => {
      const mevcut = prev.find(i => i.urun.id === urun.id);
      if (mevcut) return prev.map(i => i.urun.id === urun.id ? { ...i, miktar: i.miktar + 1, fiyat, komisyon: komisyonHesapla(urun, i.miktar + 1) } : i);
      return [...prev, { urun, miktar: 1, fiyat, komisyon, komisyonOrani: form.musteri_tipi === 'kurumsal' ? urun.kurumsal_komisyon : urun.bireysel_komisyon }];
    });
  }

  function sepetMiktarGuncelle(urunId, yeniMiktar) {
    const miktar = parseInt(yeniMiktar);
    if (isNaN(miktar) || miktar <= 0) {
      setSepet(prev => prev.filter(i => i.urun.id !== urunId));
      return;
    }
    setSepet(prev => prev.map(i => {
      if (i.urun.id !== urunId) return i;
      return { ...i, miktar, komisyon: komisyonHesapla(i.urun, miktar) };
    }));
  }

  function hesapla() {
    let tutar = 0, komisyon = 0, maliyet = 0;
    for (const item of sepet) {
      tutar += item.fiyat * item.miktar;
      komisyon += item.komisyon || 0;
      maliyet += (item.urun?.maliyet || 0) * item.miktar;
    }
    return { tutar, komisyon, maliyet, kar: tutar - komisyon - maliyet };
  }

  const { tutar, komisyon, maliyet, kar } = hesapla();

  const gruplar = [...new Set(urunler.map(u => (u.grup || '').trim()).filter(Boolean))].sort();
  const altGruplar = [...new Set(
    urunler.filter(u => !seciliGrup || (u.grup || '').trim() === seciliGrup)
      .map(u => (u.alt_grup || '').trim()).filter(Boolean)
  )].sort();

  const filtreliUrunler = urunler.filter(u => {
    if (urunArama && !u.ad.toLowerCase().includes(urunArama.toLowerCase())) return false;
    if (seciliGrup && (u.grup || '').trim() !== seciliGrup) return false;
    if (seciliAltGrup && (u.alt_grup || '').trim() !== seciliAltGrup) return false;
    return true;
  });

  const stokUyari = form.depo_id ? sepet.filter(item => {
    const stok = stokMap[item.urun?.id];
    return stok !== undefined && stok < item.miktar;
  }).map(item => `${item.urun?.ad}: Stokta ${stokMap[item.urun?.id]} adet var, ${item.miktar} adet istendi`) : [];

  const isTemsilci = profil?.rol === 'temsilci';

  async function handleKaydet() {
    if (!form.depo_id) { setHata('Lütfen depo seçin!'); return; }
    if (sepet.length === 0) { setHata('Sepet boş!'); return; }
    if (!yeniMusteri && !seciliMusteri) { setHata('Müşteri seçin!'); return; }
    if (yeniMusteri && !form.yeni_musteri_ad) { setHata('Müşteri adı girin!'); return; }

    setYukleniyor(true);
    setHata('');

    try {
      let musteri_id = seciliMusteri?.id;

      if (yeniMusteri) {
        const { data: ym, error: yhe } = await supabase.from('musteriler').insert({
          ad: form.yeni_musteri_ad, telefon: form.yeni_musteri_tel,
          sehir: form.yeni_musteri_sehir, musteri_tipi: form.yeni_musteri_tip,
          temsilci_id: profil?.id
        }).select().single();
        if (yhe) throw yhe;
        musteri_id = ym.id;
      }

      if (musteri_id && form.adres) {
        await supabase.from('musteriler').update({ adres: form.adres }).eq('id', musteri_id);
      }

      const { data: siparis, error: se } = await supabase.from('siparisler').insert({
        musteri_id, temsilci_id: profil?.id, depo_id: form.depo_id,
        firma_id: seciliFirma, odeme_turu: form.odeme_turu, kdv_durumu: form.kdv_durumu,
        musteri_tipi: form.musteri_tipi, toplam_tutar: tutar, toplam_komisyon: komisyon,
        toplam_maliyet: maliyet, net_kar: kar, adres: form.adres, not_: form.not_,
        fatura_durumu: form.fatura_durumu, kargo_kodu: form.kargo_kodu,
      }).select().single();
      if (se) throw se;

      const kalemler = sepet.map(item => ({
        siparis_id: siparis.id,
        urun_id: item.urun.id,
        miktar: item.miktar,
        birim_fiyat: item.fiyat,
        komisyon_orani: item.komisyonOrani || 0,
        komisyon_tutari: item.komisyon || 0,
        maliyet: item.urun.maliyet || 0,
        toplam: item.fiyat * item.miktar,
      }));

      const { error: kalemErr } = await supabase.from('siparis_kalemleri').insert(kalemler);
      if (kalemErr) console.error('siparis_kalemleri insert error:', kalemErr);

      for (const item of sepet) {
        const { data: stok } = await supabase.from('depo_stok').select('miktar').eq('depo_id', form.depo_id).eq('urun_id', item.urun.id).maybeSingle();
        const onceki = Number(stok?.miktar) || 0;
        const yeni = Math.max(0, onceki - item.miktar);
        await supabase.from('depo_stok').upsert({ depo_id: form.depo_id, urun_id: item.urun.id, miktar: yeni }, { onConflict: 'depo_id,urun_id' });
        await supabase.from('stok_hareketleri').insert({ depo_id: form.depo_id, urun_id: item.urun.id, hareket_tipi: 'cikis', miktar: item.miktar, onceki_stok: onceki, sonraki_stok: yeni, siparis_id: siparis.id, yapan: profil?.id });
      }

      // Mail gönder
      try {
        emailjs.init('SThZhgM7_oNjiAa72');
        await emailjs.send('service_tlwaq1p', 'template_usp871b', {
          to_email: 'fipwars01@gmail.com',
          musteri_adi: yeniMusteri ? form.yeni_musteri_ad : (seciliMusteri?.ad || ''),
          temsilci_adi: (profil?.ad || '') + ' ' + (profil?.soyad || ''),
          urunler: sepet.map(i => i.urun.ad + ' x' + i.miktar).join(', '),
          toplam: tutar.toLocaleString('tr-TR'),
          depo: depolar.find(d => d.id === form.depo_id)?.ad || '',
          tarih: new Date().toLocaleString('tr-TR'),
        }, 'SThZhgM7_oNjiAa72');
      } catch (mailErr) {
        console.error('Mail gönderilemedi:', mailErr);
      }

      navigate('/siparisler');
    } catch (err) {
      setHata(err.message || 'Hata oluştu');
    }
    setYukleniyor(false);
  }

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Sipariş Oluştur</h1>
          <p className="page-subtitle">Adım {adim}/2 — {adim === 1 ? 'Ürün Seçimi' : 'Müşteri & Detaylar'}</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {adim === 2 && <button className="btn btn-ghost" onClick={() => setAdim(1)}>← Geri</button>}
          <button className="btn btn-ghost" onClick={() => navigate('/siparisler')}>İptal</button>
        </div>
      </div>

      {hata && <div className="alert alert-error" style={{ marginBottom: 12 }}>{hata}</div>}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 320px', gap: 20 }}>
        <div>
          {adim === 1 && (
            <div className="card">
              <h3 style={{ marginBottom: 16, fontSize: 15, fontWeight: 700 }}>Ürün Seçimi</h3>
              <div className="form-row cols-2" style={{ marginBottom: 12 }}>
                <div className="form-group">
                  <label className="label">Firma</label>
                  <select className="select" value={seciliFirma} onChange={e => { setSeciliFirma(e.target.value); setSeciliGrup(''); setSeciliAltGrup(''); }}>
                    <option value="">Firma Seçin</option>
                    {firmalar.map(f => <option key={f.id} value={f.id}>{f.ad}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="label">Ürün Ara</label>
                  <input className="input" placeholder="Ürün adı..." value={urunArama} onChange={e => setUrunArama(e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="label">Depo *</label>
                  <select className="select" value={form.depo_id} onChange={e => setForm(f => ({ ...f, depo_id: e.target.value }))}>
                    <option value="">Depo Seçin</option>
                    {depolar.map(d => <option key={d.id} value={d.id}>{d.ad}</option>)}
                  </select>
                </div>
              </div>
              {seciliFirma && (
                <div style={{ marginBottom: 16 }}>
                  <label className="label">Alt Grup</label>
                  <select className="select" value={seciliAltGrup} onChange={e => setSeciliAltGrup(e.target.value)}>
                    <option value="">Tümü</option>
                    {altGruplar.map(g => <option key={g} value={g}>{g}</option>)}
                  </select>
                </div>
              )}

              {/* BROILER: Satış Tipi Seçimi */}
              {seciliFirma === BROILER_ID && (
                <div style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 14, marginBottom: 16 }}>
                  <div className="label" style={{ marginBottom: 10 }}>Satış Tipi *</div>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: form.broiler_satis_tipi === 'entegre' ? 12 : 0 }}>
                    {[
                      { val: 'ciftlik', label: '🐔 Çiftlik' },
                      { val: 'bayi', label: '🏪 Bayi' },
                      { val: 'entegre', label: '🏭 Entegre Tesis' },
                    ].map(({ val, label }) => (
                      <button key={val}
                        className={`btn btn-sm ${form.broiler_satis_tipi === val ? 'btn-primary' : 'btn-ghost'}`}
                        onClick={() => {
                          setForm(f => ({ ...f, broiler_satis_tipi: val, musteri_tipi: val, entegre_manuel_fiyat: '' }));
                          setEntegreFiyatlar({});
                          setEntegreFiyatAcik({});
                          setSepet([]); // Fiyat değiştiği için sepeti temizle
                        }}>
                        {label}
                      </button>
                    ))}
                  </div>
                  {form.broiler_satis_tipi === 'entegre' && (
                    <div style={{ marginTop: 12 }}>
                      <label className="label">Birim Fiyat (₺) *</label>
                      <input
                        className="input"
                        type="number"
                        step="0.01"
                        placeholder="Entegre tesis satış fiyatını girin..."
                        value={form.entegre_manuel_fiyat}
                        onChange={e => {
                          setForm(f => ({ ...f, entegre_manuel_fiyat: e.target.value }));
                          setSepet([]); // Fiyat değişince sepeti sıfırla
                        }}
                      />
                      <div style={{ fontSize: 11, color: 'var(--text2)', marginTop: 4 }}>Bu fiyat sepetteki tüm entegre ürünlere uygulanır</div>
                    </div>
                  )}
                </div>
              )}
              <table className="table">
                <thead>
                  <tr><th>Ürün</th><th>Grup</th><th>Satış Tipi</th><th>Fiyat</th><th></th></tr>
                </thead>
                <tbody>
                  {!seciliFirma ? (
                    <tr><td colSpan={5} style={{ textAlign: 'center', padding: 30, color: 'var(--text2)' }}>Firma seçin</td></tr>
                  ) : filtreliUrunler.length === 0 ? (
                    <tr><td colSpan={5} style={{ textAlign: 'center', padding: 30, color: 'var(--text2)' }}>Ürün bulunamadı</td></tr>
                  ) : filtreliUrunler.map(u => (
                    <tr key={u.id}>
                      <td>
                        <div style={{ fontWeight: 500 }}>{u.ad}</div>
                        {form.depo_id && (
                          <div style={{ fontSize: 11, marginTop: 2 }}>
                            {stokMap[u.id] === undefined ? (
                              <span style={{ color: 'var(--text2)' }}>Stok bilgisi yok</span>
                            ) : stokMap[u.id] === 0 ? (
                              <span style={{ color: 'var(--red)', fontWeight: 600 }}>⛔ Stok Yok</span>
                            ) : stokMap[u.id] <= 5 ? (
                              <span style={{ color: 'var(--yellow)', fontWeight: 600 }}>⚠️ Az Stok: {stokMap[u.id]} adet</span>
                            ) : (
                              <span style={{ color: 'var(--green)' }}>✓ Stok: {stokMap[u.id]} adet</span>
                            )}
                          </div>
                        )}
                      </td>
                      <td style={{ color: 'var(--text2)', fontSize: 12 }}>{u.alt_grup || u.grup}</td>
                      <td>
                        <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                          {seciliFirma === BROILER_ID ? (
                            <span style={{ fontSize: 13, color: 'var(--green)', fontWeight: 600 }}>
                              {form.broiler_satis_tipi === 'entegre'
                                ? (parseFloat(form.entegre_manuel_fiyat) > 0 ? `${parseFloat(form.entegre_manuel_fiyat).toLocaleString('tr-TR')} ₺` : 'Fiyat girilmedi')
                                : form.broiler_satis_tipi === 'bayi'
                                  ? `🏪 ${(u.bayi_fiyat || 0).toLocaleString('tr-TR')} ₺`
                                  : `🐔 ${(u.ciftlik_fiyat || 0).toLocaleString('tr-TR')} ₺`}
                            </span>
                          ) : (
                            <>
                              <button
                                className={'btn btn-sm ' + ((!satisGrubu[u.id] || satisGrubu[u.id] === 'veteriner') ? 'btn-primary' : 'btn-ghost')}
                                style={{ fontSize: 11, padding: '3px 8px' }}
                                onClick={() => satisGrubuSec(u.id, 'veteriner')}
                              >
                                🩺 Vet: {((form.odeme_turu === 'kredi_karti' ? u.kk_fiyat_kdvli : u.banka_fiyat_kdvsiz) || 0).toLocaleString('tr-TR')} ₺
                              </button>
                              {(u.satis_tipi || '').trim() === 'hepsi' && (
                                <button
                                  className={'btn btn-sm ' + (satisGrubu[u.id] === 'hasta_yakini' ? 'btn-primary' : 'btn-ghost')}
                                  style={{ fontSize: 11, padding: '3px 8px' }}
                                  onClick={() => satisGrubuSec(u.id, 'hasta_yakini')}
                                >
                                  🏥 HY: {((form.odeme_turu === 'kredi_karti' ? u.hya_kk_fiyat : u.hya_banka_fiyat) || 0).toLocaleString('tr-TR')} ₺
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      </td>
                      <td style={{ color: 'var(--green)', fontWeight: 600 }}>
                        {seciliFirma === BROILER_ID && form.broiler_satis_tipi === 'entegre' ? (
                          entegreFiyatAcik[u.id] ? (
                            <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                              <input
                                className="input"
                                type="number"
                                step="0.01"
                                placeholder="Fiyat..."
                                value={entegreFiyatlar[u.id] || ''}
                                onChange={e => setEntegreFiyatlar(p => ({ ...p, [u.id]: e.target.value }))}
                                style={{ width: 100, padding: '4px 8px' }}
                                autoFocus
                              />
                              <button className="btn btn-primary btn-sm" onClick={() => {
                                const fiyat = parseFloat(entegreFiyatlar[u.id]);
                                if (!fiyat || fiyat <= 0) return;
                                setEntegreFiyatAcik(p => ({ ...p, [u.id]: false }));
                                sepeteEkle(u);
                              }}>✓</button>
                              <button className="btn btn-ghost btn-sm" onClick={() => setEntegreFiyatAcik(p => ({ ...p, [u.id]: false }))}>✕</button>
                            </div>
                          ) : (
                            <span style={{ color: entegreFiyatlar[u.id] ? 'var(--green)' : 'var(--text2)', fontSize: 13 }}>
                              {entegreFiyatlar[u.id] ? `${parseFloat(entegreFiyatlar[u.id]).toLocaleString('tr-TR')} ₺` : 'Fiyat gir'}
                            </span>
                          )
                        ) : (
                          <span>{(birimFiyat(u) || 0).toLocaleString('tr-TR')} ₺</span>
                        )}
                      </td>
                      <td>
                        {seciliFirma === BROILER_ID && form.broiler_satis_tipi === 'entegre' && !entegreFiyatAcik[u.id] ? (
                          <button
                            className="btn btn-primary btn-sm"
                            disabled={form.depo_id && (stokMap[u.id] === undefined || stokMap[u.id] === 0)}
                            style={form.depo_id && (stokMap[u.id] === undefined || stokMap[u.id] === 0) ? { opacity: 0.4 } : {}}
                            onClick={() => {
                              if (form.depo_id && (stokMap[u.id] === undefined || stokMap[u.id] === 0)) return;
                              setEntegreFiyatAcik(p => ({ ...p, [u.id]: true }));
                            }}>
                            {form.depo_id && (stokMap[u.id] === undefined || stokMap[u.id] === 0) ? '⛔ Stok Yok' : entegreFiyatlar[u.id] ? '+ Ekle' : '💰 Fiyat Gir'}
                          </button>
                        ) : !entegreFiyatAcik[u.id] ? (
                          <button
                            className={`btn btn-sm ${form.depo_id && (stokMap[u.id] === undefined || stokMap[u.id] === 0) ? 'btn-ghost' : 'btn-primary'}`}
                            disabled={form.depo_id && (stokMap[u.id] === undefined || stokMap[u.id] === 0)}
                            style={form.depo_id && (stokMap[u.id] === undefined || stokMap[u.id] === 0) ? { opacity: 0.4, cursor: 'not-allowed' } : {}}
                            onClick={() => sepeteEkle(u)}>
                            {form.depo_id && (stokMap[u.id] === undefined || stokMap[u.id] === 0) ? '⛔ Stok Yok' : '+ Ekle'}
                          </button>
                        ) : null}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {adim === 2 && (
            <div className="card">
              <h3 style={{ marginBottom: 16, fontSize: 15, fontWeight: 700 }}>Müşteri & Sipariş Detayları</h3>
              <div style={{ marginBottom: 16 }}>
                <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                  <button className={`btn ${!yeniMusteri ? 'btn-primary' : 'btn-ghost'} btn-sm`} onClick={() => { setYeniMusteri(false); setSeciliMusteri(null); setMusteriArama(''); }}>Mevcut Müşteri</button>
                  <button className={`btn ${yeniMusteri ? 'btn-primary' : 'btn-ghost'} btn-sm`} onClick={() => { setYeniMusteri(true); setSeciliMusteri(null); }}>+ Yeni Müşteri</button>
                </div>
                {!yeniMusteri ? (
                  <div style={{ position: 'relative' }}>
                    <input className="input" placeholder="Müşteri adı veya telefon..." value={musteriArama} onChange={e => { setMusteriArama(e.target.value); setSeciliMusteri(null); }} autoComplete="off" />
                    {musteriAraniyor && <div style={{ padding: 10, color: 'var(--text2)', fontSize: 13 }}>Aranıyor...</div>}
                    {musteriSonuclar.length > 0 && (
                      <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 100, background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', boxShadow: 'var(--shadow)', maxHeight: 220, overflowY: 'auto' }}>
                        {musteriSonuclar.map(m => (
                          <div key={m.id} onClick={() => musteriSec(m)}
                            style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                            onMouseOver={e => e.currentTarget.style.background = 'var(--bg3)'}
                            onMouseOut={e => e.currentTarget.style.background = 'transparent'}>
                            <div>
                              <span style={{ fontWeight: 600 }}>{m.ad}</span>
                              <span style={{ fontSize: 11, color: 'var(--text2)', marginLeft: 8 }}>{m.musteri_tipi}</span>
                            </div>
                            <span style={{ fontSize: 12, color: 'var(--text2)' }}>{m.sehir} • {m.telefon}</span>
                          </div>
                        ))}
                      </div>
                    )}
                    {seciliMusteri && (
                      <>
                        <div style={{ marginTop: 8, padding: '8px 12px', background: 'rgba(224,123,0,0.1)', border: '1px solid var(--accent)', borderRadius: 'var(--r)', display: 'flex', justifyContent: 'space-between' }}>
                          <span style={{ fontWeight: 600, color: 'var(--accent)' }}>✓ {seciliMusteri.ad}</span>
                          <span style={{ fontSize: 12, color: 'var(--text2)' }}>{seciliMusteri.sehir} • {seciliMusteri.telefon}</span>
                        </div>
                        <div className="form-group" style={{ marginTop: 8 }}>
                          <label className="label">Şehir</label>
                          <select className="select" value={form.sehir} onChange={e => setForm(f => ({ ...f, sehir: e.target.value }))}>
                            <option value="">Şehir seçin...</option>
                            {TURKIYE_SEHIRLER.map(s => <option key={s} value={s}>{s}</option>)}
                          </select>
                        </div>
                      </>
                    )}
                    {musteriArama.length >= 2 && musteriSonuclar.length === 0 && !musteriAraniyor && !seciliMusteri && (
                      <div style={{ marginTop: 8, padding: '8px 12px', background: 'var(--bg3)', borderRadius: 'var(--r)', fontSize: 13, color: 'var(--text2)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>Müşteri bulunamadı</span>
                        <button className="btn btn-primary btn-sm" onClick={() => { setYeniMusteri(true); setForm(f => ({ ...f, yeni_musteri_ad: musteriArama })); }}>+ Yeni Ekle</button>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="form-row cols-2">
                    <div className="form-group"><label className="label">Ad Soyad *</label><input className="input" value={form.yeni_musteri_ad} onChange={e => setForm(f => ({ ...f, yeni_musteri_ad: e.target.value }))} autoComplete="off" /></div>
                    <div className="form-group"><label className="label">Telefon</label><input className="input" value={form.yeni_musteri_tel} onChange={e => setForm(f => ({ ...f, yeni_musteri_tel: e.target.value }))} autoComplete="off" maxLength={15} /></div>
                    <div className="form-group" style={{ position: 'relative' }}>
                      <label className="label">Şehir</label>
                      <input
                        className="input"
                        placeholder="Şehir ara... (İ, M, S...)"
                        value={form.yeni_musteri_sehir}
                        onChange={e => setForm(f => ({ ...f, yeni_musteri_sehir: e.target.value }))}
                        autoComplete="off"
                      />
                      {form.yeni_musteri_sehir.length >= 1 && !TURKIYE_SEHIRLER.includes(form.yeni_musteri_sehir) && (
                        <div style={{
                          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 999,
                          background: 'var(--bg2)', border: '1px solid var(--border)',
                          borderRadius: 'var(--r)', maxHeight: 200, overflowY: 'auto',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                        }}>
                          {TURKIYE_SEHIRLER
                            .filter(s => s.toLowerCase().startsWith(form.yeni_musteri_sehir.toLowerCase()) ||
                              s.toLowerCase().replace(/ı/g,'i').replace(/ş/g,'s').replace(/ğ/g,'g').replace(/ü/g,'u').replace(/ö/g,'o').replace(/ç/g,'c')
                                .startsWith(form.yeni_musteri_sehir.toLowerCase().replace(/ı/g,'i').replace(/ş/g,'s').replace(/ğ/g,'g').replace(/ü/g,'u').replace(/ö/g,'o').replace(/ç/g,'c')))
                            .slice(0, 10)
                            .map(s => (
                              <div key={s}
                                style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid var(--border)', fontSize: 14 }}
                                onMouseDown={() => setForm(f => ({ ...f, yeni_musteri_sehir: s }))}
                                onTouchStart={() => setForm(f => ({ ...f, yeni_musteri_sehir: s }))}>
                                {s}
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              <div className="form-row cols-2">
                <div className="form-group">
                  <label className="label">Müşteri Tipi (Komisyon)</label>
                  <select className="select" value={form.musteri_tipi}
                    disabled={seciliFirma === BROILER_ID}
                    onChange={e => setForm(f => ({ ...f, musteri_tipi: e.target.value }))}>
                    {seciliFirma === BROILER_ID ? (
                      <>
                        <option value="ciftlik">Çiftlik</option>
                        <option value="bayi">Bayi</option>
                        <option value="entegre">Entegre Tesis</option>
                      </>
                    ) : (
                      <>
                        <option value="bireysel">Bireysel</option>
                        {seciliFirma !== FIPGL23_ID && <option value="kurumsal">Kurumsal</option>}
                      </>
                    )}
                  </select>
                  {seciliFirma === BROILER_ID && (
                    <div style={{ fontSize: 11, color: 'var(--text2)', marginTop: 4 }}>
                      Adım 1'de seçilen: {form.broiler_satis_tipi === 'ciftlik' ? '🐔 Çiftlik' : form.broiler_satis_tipi === 'bayi' ? '🏪 Bayi' : '🏭 Entegre Tesis'}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label className="label">Ödeme Türü</label>
                  <select className="select" value={form.odeme_turu} onChange={e => setForm(f => ({ ...f, odeme_turu: e.target.value }))}>
                    {seciliFirma === BROILER_ID ? (
                      <>
                        <option value="banka">Banka Havalesi</option>
                        <option value="elden">Elden / Nakit</option>
                        <option value="kredi_karti">Kredi Kartı</option>
                        <option value="cek">Çek</option>
                        <option value="senet">Senet</option>
                      </>
                    ) : seciliFirma === FIPGL23_ID ? (
                      <>
                        <option value="banka">Banka Havalesi (KDV'siz)</option>
                        <option value="elden">Elden / Nakit (KDV'siz)</option>
                      </>
                    ) : (
                      <>
                        <option value="banka">Banka Havalesi (KDV'siz)</option>
                        <option value="elden">Elden / Nakit (KDV'siz)</option>
                        <option value="kredi_karti">Kredi Kartı (KDV'li)</option>
                      </>
                    )}
                  </select>
                </div>

                <div className="form-group">
                  <label className="label">Kargo Takip No</label>
                  <input className="input" value={form.kargo_kodu} onChange={e => setForm(f => ({ ...f, kargo_kodu: e.target.value }))} placeholder="Kargo takip numarası..." autoComplete="off" />
                </div>
              </div>

              <div className="form-group">
                <label className="label">Teslimat Adresi</label>
                <textarea className="textarea" value={form.adres} onChange={e => setForm(f => ({ ...f, adres: e.target.value }))} placeholder="Teslimat adresi..." />
              </div>
              <div className="form-group">
                <label className="label">Not</label>
                <textarea className="textarea" value={form.not_} onChange={e => setForm(f => ({ ...f, not_: e.target.value }))} />
              </div>
              <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                <input type="checkbox" checked={form.fatura_durumu} onChange={e => setForm(f => ({ ...f, fatura_durumu: e.target.checked }))} />
                <span>Fatura Kesildi</span>
              </label>
            </div>
          )}
        </div>

        {/* SEPET */}
        <div>
          <div className="card" style={{ position: 'sticky', top: 20 }}>
            <h3 style={{ marginBottom: 12, fontSize: 15, fontWeight: 700 }}>Sepet ({sepet.length} ürün)</h3>
            {sepet.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '20px 0', color: 'var(--text2)', fontSize: 13 }}>Henüz ürün eklenmedi</div>
            ) : (
              <>
                {sepet.map(({ urun, miktar, fiyat }) => (
                  <div key={urun.id} style={{ padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
                    <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 4 }}>{urun.ad}</div>
                    <div style={{ fontSize: 11, color: 'var(--text2)', marginBottom: 6 }}>
                      {urun.firma_id === BROILER_ID ? (
                        form.musteri_tipi === 'ciftlik' ? '🐔 Çiftlik' :
                        form.musteri_tipi === 'bayi' ? '🏪 Bayi' : '🏭 Entegre Tesis'
                      ) : satisGrubu[urun.id] === 'hasta_yakini' ? '🏥 Hasta Yakını' : '🩺 Veteriner'} •
                      {urun.firma_id === BROILER_ID
                        ? ` ${form.odeme_turu === 'banka' ? 'Banka Havalesi' : form.odeme_turu === 'elden' ? 'Elden/Nakit' : form.odeme_turu === 'cek' ? 'Çek' : form.odeme_turu === 'senet' ? 'Senet' : 'Kredi Kartı'}`
                        : form.odeme_turu === 'kredi_karti' ? ' Kredi Kartı (KDV\'li)' : ' Banka/Elden (KDV\'siz)'}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <button className="btn btn-ghost btn-sm" onClick={() => sepetMiktarGuncelle(urun.id, miktar - 1)}>−</button>
                      <input type="number" className="input" style={{ width: 60, textAlign: 'center' }} value={miktar} onChange={e => sepetMiktarGuncelle(urun.id, e.target.value)} min={1} />
                      <button className="btn btn-ghost btn-sm" onClick={() => sepetMiktarGuncelle(urun.id, miktar + 1)}>+</button>
                      <button className="btn btn-danger btn-sm" onClick={() => sepetMiktarGuncelle(urun.id, 0)}>✕</button>
                      <span style={{ marginLeft: 'auto', fontWeight: 600, fontSize: 13 }}>{(fiyat * miktar).toLocaleString('tr-TR')} ₺</span>
                    </div>
                  </div>
                ))}
                <div style={{ marginTop: 16, paddingTop: 12, borderTop: '1px solid var(--border)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 13 }}>
                    <span style={{ color: 'var(--text2)' }}>Toplam Tutar</span>
                    <span style={{ fontWeight: 700 }}>{tutar.toLocaleString('tr-TR')} ₺</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 13 }}>
                    <span style={{ color: 'var(--text2)' }}>Komisyon</span>
                    <span style={{ color: 'var(--yellow)' }}>{komisyon.toLocaleString('tr-TR')} ₺</span>
                  </div>
                  {!isTemsilci && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
                      <span style={{ color: 'var(--text2)' }}>Net Kar</span>
                      <span style={{ color: 'var(--green)', fontWeight: 700 }}>{kar.toLocaleString('tr-TR')} ₺</span>
                    </div>
                  )}
                </div>
              </>
            )}
            <div style={{ marginTop: 16 }}>
              {adim === 1 ? (
                <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}
                  onClick={() => {
                    if (!form.depo_id) { setHata('Lütfen depo seçin!'); return; }
                    if (sepet.length === 0) { setHata('Sepet boş!'); return; }
                    setAdim(2); setHata('');
                  }}
                  disabled={sepet.length === 0}>
                  Devam Et →
                </button>
              ) : (
                <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} onClick={handleKaydet} disabled={yukleniyor}>
                  {yukleniyor ? 'Kaydediliyor...' : '✓ Sipariş Oluştur'}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
